import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FAQ_WORKFLOW_STEPS } from '../../data/faqData';
import './FaqWorkflowGuide.css';

export function FaqWorkflowGuide() {
  const { t } = useTranslation();

  return (
    <section className="saas-faq-flow" aria-labelledby="saas-faq-flow-title">
      <div className="saas-faq-flow__head">
        <h2 id="saas-faq-flow-title" className="saas-faq-flow__title">
          {t('faq.workflowTitle')}
        </h2>
        <p className="saas-faq-flow__sub">{t('faq.workflowSub')}</p>
      </div>
      <ol className="saas-faq-flow__steps">
        {FAQ_WORKFLOW_STEPS.map((s) => (
          <li key={s.itemId} className="saas-faq-flow__step">
            <Link to={`/faq?id=${s.itemId}`} className="saas-faq-flow__card">
              <span className="saas-faq-flow__num" aria-hidden="true">
                {s.step}
              </span>
              <span className="saas-faq-flow__icon" aria-hidden="true">
                {s.icon}
              </span>
              <span className="saas-faq-flow__label">
                {t(`faq.workflowSteps.${s.itemId}`)}
              </span>
              <span className="saas-faq-flow__arrow" aria-hidden="true">
                →
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
}
